import { createGlobalStyle } from "styled-components";

const GlobalStyle = createGlobalStyle`
  * {
    font-family: "Inter", sans-serif;
  }
`;

export default GlobalStyle;
